import {CURSOR_MARK, MarkedInput} from './types';

const markCursorPosition = (s: string, start: number, end: number): MarkedInput =>
  [...s.slice(0, start), CURSOR_MARK, ...s.slice(end)]

export default markCursorPosition;
